import React from "react";
import {
  Grid,
  Button,
  Checkbox,
  Popover,
  SvgIcon,
  Badge,
  FormControlLabel,
  Box,
} from "@material-ui/core";
import { ReactComponent as filterIcon } from "../../assets/icons/filter-icon.svg";
import AppConstants from "../../constants";

interface VehicleFilterPopoverProps {
  anchorEl: HTMLDivElement | null;
  open: boolean;
  pendingVehicles: string[];
  selectedCount: number;
  isAllSelected: boolean;
  isIndeterminate: boolean;
  vehicleOptions: string[];
  classes: any;
  onOpen: (event: React.MouseEvent<HTMLDivElement>) => void;
  onClose: () => void;
  onToggle: (vehicle: string) => void;
  onSelectAll: () => void;
  onApply: () => void;
  onClear: () => void;
}

export const VehicleFilterPopover: React.FC<VehicleFilterPopoverProps> = ({
  anchorEl,
  open,
  pendingVehicles,
  selectedCount,
  isAllSelected,
  isIndeterminate,
  vehicleOptions,
  classes,
  onOpen,
  onClose,
  onToggle,
  onSelectAll,
  onApply,
  onClear,
}) => {
  return (
    <>
      <Box className={classes.vehicleFilterTrigger} onClick={onOpen}>
        <span className={classes.vehicleFilterText}>
          {"Select Vehicle"}
        </span>
        <Badge
          badgeContent={selectedCount}
          color="primary"
          invisible={selectedCount === 0}
          className={classes.vehicleFilterBadge}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <SvgIcon
            viewBox="0 0 24 24"
            component={filterIcon}
            className={classes.vehicleFilterIcon}
          />
        </Badge>
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          className: classes.vehiclePopoverPaper,
        }}
      >
        <Box className={classes.vehiclePopoverContent}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isAllSelected}
                indeterminate={isIndeterminate}
                onChange={onSelectAll}
                color="primary"
                size="small"
                className={classes.filterCheckbox}
              />
            }
            label={<span className={classes.selectAllLabel}>Select All</span>}
            className={classes.vehicleItemContainer}
            style={{ marginBottom: 8 }}
          />

          <Box className={classes.filterDivider}>
            {vehicleOptions.map((vehicle, index) => (
              <FormControlLabel
                key={vehicle}
                control={
                  <Checkbox
                    checked={pendingVehicles.includes(vehicle)}
                    onChange={() => onToggle(vehicle)}
                    color="primary"
                    size="small"
                    className={classes.filterCheckbox}
                  />
                }
                label={<span className={classes.vehicleItemLabel}>{vehicle}</span>}
                className={classes.vehicleItemContainer}
                style={{
                  marginBottom: index === vehicleOptions.length - 1 ? 0 : 12,
                  paddingBottom: index === vehicleOptions.length - 1 ? 0 : 12,
                  borderBottom:
                    index === vehicleOptions.length - 1
                      ? "none"
                      : "1px solid #e0e0e0",
                }}
              />
            ))}
          </Box>

          <Grid container spacing={1} className={classes.filterButtonsContainer}>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                fullWidth
                onClick={onApply}
                className={classes.filterButton}
              >
                {AppConstants.BUTTONS.APPLY}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="default"
                size="small"
                fullWidth
                onClick={onClear}
                className={classes.filterButton}
              >
                {AppConstants.BUTTONS.CLEAR}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </>
  );
};

export default VehicleFilterPopover;
